import ky from 'ky';
import { z } from 'zod';
import { ENV } from 'src/utils/env';
import { getHeadersWithBearerToken } from 'src/utils/get-auth-with-bearer';

const EDIT_DEVICE_DETAILS_SCHEMA = z.object({
  display_name: z.string().optional(),
  device_id: z.string(),
  location_id: z.string().optional(),
  sim_card_id: z.string().optional(),
  organisations: z.string().array().optional(),
  is_live: z.boolean().optional(),
  start_time: z.string().optional(),
  end_time: z.string().optional(),
});

export type EditDeviceDetailsSchema = z.infer<typeof EDIT_DEVICE_DETAILS_SCHEMA>;

export const editDeviceDetailsPromise = async (param: EditDeviceDetailsSchema) => {
  try {
    const headers = getHeadersWithBearerToken();
    headers.append('Content-Type', 'application/json');

    if (!EDIT_DEVICE_DETAILS_SCHEMA.safeParse(param).success) {
      console.error('Invalid Params');
      throw new Error('Invalid Params');
    }

    try {
      const response = await ky.patch(`${ENV.API_URL}/api/displays/${param.device_id}/`, {
        headers,
        body: JSON.stringify({
          payload: JSON.stringify(param),
        }),
      });

      if (response.ok) {
        return true;
      }

      console.error('Non 200 response in editDeviceDetailsPromise', response.status);

      return false;
    } catch (error) {
      console.error('Error in editDeviceDetailsPromise', error);
      throw new Error('Error in editDeviceDetailsPromise');
    }
  } catch (error) {
    console.error('Error in editDeviceDetailsPromise', error);
    throw new Error('Error in editDeviceDetailsPromise');
  }
};
